import React from "react";
import { Box, Typography } from "@mui/material";
import RentalPropertyList from "../pages/rental-property/RentalPropertyList";

const RentalPropertyContainer = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Rental Property
      </Typography>
      <Typography variant="h6" sx={{ mb: 8, color: "#666" }}>
        Here, you can manage your rental properties and view detailed, tabular
        information to your inventory.
      </Typography>
      <RentalPropertyList />
    </Box>
  );
};

export default RentalPropertyContainer;
